module.exports = __webpack_public_path__ + "7161d36bcb43349179c0d3915e8eddb1.pdf";